var isNode = !global.window

if (isNode) {
  module.exports = require('crypto')
} else {
  module.exports = require('crypto-browserify')
}



//////////////////
// WEBPACK FOOTER
// /root/anvel/~/webcrypto/src/index.js
// module id = ../../../../webcrypto/src/index.js
// module chunks = 4